module.exports = __webpack_public_path__ + "img/floor_UG1.7e8a4c41.svg";